<ng-template #header>
  <app-header-static-image
    [pageTitle]="headerTitle"
    [imageUrl]="imageHeader"
  ></app-header-static-image>
</ng-template>

<router-outlet></router-outlet>
